module.exports = __webpack_public_path__ + "img/quota-message.83826bf9.svg";